import { BillingFreeItem } from "./billing-free-item";
import { BillingType } from "./billing-type";
import { Company } from "./company";
import { Site } from "./site";

export class BillingFree {
    id?: string;
    company?: Company;
    companyId?: string | null;
    site?: Site
    siteId?: string | null;
    billingType?: BillingType;
    billingTypeId?: string | null;
    date?: Date;
    creationDate?: Date;
    comment?: string;

    billingFreeItems?: BillingFreeItem[];

    constructor(billingFree?: BillingFree) {
        this.id = billingFree?.id;
        this.companyId = billingFree?.companyId || (billingFree?.company ? billingFree?.company.id : null);
        this.company = billingFree?.company;
        this.siteId = billingFree?.siteId || (billingFree?.site ? billingFree?.site.id : null);
        this.site = billingFree?.site;
        this.billingTypeId = billingFree?.billingTypeId || (billingFree?.billingType ? billingFree?.billingType.id : null);
        this.billingType = billingFree?.billingType;
        this.date = billingFree?.date;
        this.creationDate = billingFree?.creationDate;
        this.comment = billingFree?.comment;
        
        this.billingFreeItems = billingFree?.billingFreeItems || [];
    }
}

